import '../assets/styles/Spinner.css';  // Add custom CSS for the spinner

const Spinner = ({ loading }) => (

    loading ? <div className="spinner"></div> : ''
);

export default Spinner;
